module.exports = __webpack_public_path__ + "img/julsing.0c95ff1b.png";